

export const getNotebooksById = (state) => state.notebooks || {};

export const getNumNotebooks = (state) => Object.keys(state.notebooks || {})?.length ?? 0;